<template>
    <Panel size="full" padding="p-5">
        <div class="flex gap-4">
            <div class="shrink-0">
                <Avatar :size="24" :src="displayProfile.avatar" :alt="displayProfile.tag_name" />
            </div>
            <div class="flex h-24 flex-1 flex-col justify-between">
                <div class="flex items-center justify-between">
                    <div class="text-lg font-bold text-white">{{ displayProfile.tag_name }}</div>
                    <router-link :to="{ name: 'profile-edit' }" data-testid="profile-edit-link">
                        <svg
                            class="size-5"
                            viewBox="0 0 19 19"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M18.4141 6.02246L5.72949 18.707L5.4375 19H0V13.5625L0.292969 13.2705L12.9775 0.585938L18.4141 6.02246ZM2 14.3916V17H4.6084L12.7051 8.90234L10.0967 6.29395L2 14.3916ZM11.5117 4.87988L14.1201 7.48828L15.5859 6.02246L12.9775 3.41406L11.5117 4.87988Z"
                                fill="#FF2C2C"
                            />
                        </svg>
                    </router-link>
                </div>

                <div class="grid grid-cols-2 gap-4">
                    <Panel
                        size="full"
                        border-color="bg-stroke-1"
                        background-color="bg-card-2"
                        padding="p-2"
                        class="flex text-center justify-center text-sm"
                    >
                        {{ $t('general.wins_label') }}<br/> <strong>{{ wins }}</strong>
                    </Panel>
                    <Panel
                        size="full"
                        border-color="bg-stroke-1"
                        background-color="bg-card-2"
                        padding="p-2"
                        class="flex text-center justify-center text-sm"
                    >
                        {{ $t('general.avg_label') }}<br/> <strong>{{ average }}</strong>
                    </Panel>
                </div>
            </div>
        </div>
    </Panel>
</template>

<script>
import { mapStores } from 'pinia'
import { useAuthStore } from '@/stores/auth.js'
import Panel from '@/components/layout/Panel.vue'
import Avatar from '@/components/Avatar.vue'

export default {
    name: 'ProfileHeader',
    components: {
        Panel,
        Avatar,
    },
    computed: {
        ...mapStores(useAuthStore),

        displayProfile() {
            return this.authStore.profile
        },

        allTimeStats() {
            return this.authStore.statistics?.all_time || {}
        },

        wins() {
            return this.allTimeStats.total_wins || 0
        },

        average() {
            return this.allTimeStats.three_dart_avg?.matchtype_501?.average || 0
        },
    },
}
</script>
